














import Vue from 'vue';
import * as R from 'ramda';

export default Vue.extend({
  name: 'List',
  props: {
    items: Array,
    itemsPerLine: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      itemWidth: Math.floor(12 / this.itemsPerLine),
    };
  },
  methods: {
    getLineKey<T extends Record<'id', unknown>>(items: T[]): string {
      return R.pluck('id')(items).join();
    },
    chunkItems<T>(items: Array<T>): Array<Array<T>> {
      return R.splitEvery(this.itemsPerLine, items);
    },
  },
});
